import { action } from "satcheljs";

export interface GET_FOLDER_DATAActionMessage {
    folderId: string;
}
const defaultExport: (folderId: string) => GET_FOLDER_DATAActionMessage = action("GET_FOLDER_DATA", (folderId: string): GET_FOLDER_DATAActionMessage => {
    return {
        folderId,
    };
});
export default defaultExport;
